export default __webpack_public_path__ + "static/media/arrow.7b1ff539.svg";